import events from '@/components/MultiTab/events'

export default {
  data() {
    return {
      saveType: false, //是否按钮保存
    }
  },
  created() {
    let path = this.$route.path
    sessionStorage.setItem('currentRoute',path)
  },
  methods: {

    changeSaveType() {
      this.saveType = !this.saveType
    },
    closeTag(){
        events.$emit('close', 'customeClose',)
    },
    routeCallback(res){
        let currenRoute = sessionStorage.getItem('currentRoute')
        // currenRoute = JSON.parse(currenRoute)
        // this.closeTag()
        console.log(res,'res',currenRoute)
    }
  },
}
